import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Services from "./components/Services";
import Products from "./components/Products";
import Projects from "./components/Projects";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer"; // Import Footer
import GetQuote from "./components/GetQuote";
import './styles.css'

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/quote" element={<GetQuote />} />
      </Routes>
      <Footer /> {/* Add Footer at the bottom */}
    </Router>
  );
};

export default App;
